<template>
  <RouterLink
    class="router-vertical-tab"
    :class="{ 'router-vertical-tab--active': currentTab.includes(routeFullPath) }"
    :to="routeFullPath"
  >
    <div class="router-vertical-tab__left">
      <slot name="left" />
    </div>
    <div class="router-vertical-tab__content">
      <span class="router-vertical-tab__sign">{{ label }}</span>
      <slot name="paragraph" />
    </div>
  </RouterLink>
</template>

<script lang="ts" setup>
import { computed, PropType, inject } from 'vue';
import { RouteLocationRaw, RouterLink, useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  route: {
    type: Object as PropType<RouteLocationRaw>,
    required: true,
  },
  label: {
    type: String as PropType<string | null>,
  },
  paragraph: {
    type: String as PropType<string | null>,
  },
  currentTab: {
    type: String,
  },
});

const routeFullPath = computed(() => router.resolve(props.route).fullPath);
</script>

<style lang="scss" scoped>
.router-vertical-tab {
  padding: 0.75rem;
  background-color: var(--bg-base, #fff);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;

  color: var(--text-primary, #272d37);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  &:hover,
  &--active {
    background-color: var(--neutral-translucent-10, rgba(39, 45, 55, 0.1));
  }

  &__left {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__content {
    display: flex;
    flex-direction: column;
  }
}
</style>
